import React, { useEffect, useState, useRef, useContext } from 'react';
import { Row, Col, Label, Input, Container, FormGroup, Form } from 'reactstrap';
import classNames from 'classnames';
import styles from './OrderSummary.module.css';
import SimpleReactValidator from 'simple-react-validator';
import { SalesContext } from '../contexts/SalesContext';
import { BrandingContext } from '../contexts/ContractContext';
import moment from 'moment';

let btnPrimary = 'btn-primary';
let btn = 'btn';

const PromoCode = ({ handleApplyPromoCode, isPromoApplied }) => {
    const simpleValidator = useRef(
        new SimpleReactValidator({
            messages: {
                max: 'The :attribute must not be greater than :max characters.',
                required: ':attribute is required.'
            },
            element: (message) => (
                <div
                    className='errorMsg'
                    aria-live='polite'
                >
                    {message.charAt(0).toUpperCase() + message.slice(1)}
                </div>
            )
        })
    );

    const context = useContext(SalesContext);
    const [promoCodeText, setPromoCodeText] = useState(context.data.promocodeObj?.codeText ?? '');
    const [, forceUpdate] = useState();
    const [errMsg, setErrMsg] = useState({});
    const planData = context.data.planData;
    const contractContext = useContext(BrandingContext);
    const clientId = contractContext?.data?.clientId || 'aig';
    const [errors, setErrors] = useState({
        promocode: false,
        validationPromocode: false
    });

    const validatePromoCode = async () => {
        let isValidPromo = false;
        let currentdate = moment().format('YYYY-MM-DD hh:mm:ss');
        let Promocode = '';
        const response = await fetch(
            `api/promocode/GetPromoCodeRiskProfiles/${planData.selectedPlan.riskProfile.riskProfileId}/${clientId}`
        );
        const promoCodeRiskProfileDetails = await response.json();
        let promoCodeDetails = promoCodeRiskProfileDetails.find(
            (rp) => rp.promoCodeModel.promoCodeName.toLowerCase() == promoCodeText.toLowerCase()
        );
        if (typeof promoCodeDetails !== 'undefined') {
            let ExpirationDate = moment(promoCodeDetails.expirationDate).format('YYYY-MM-DD hh:mm:ss');
            let EffectiveDate = moment(promoCodeDetails.effectiveDate).format('YYYY-MM-DD hh:mm:ss');
            let promoCodeType = promoCodeDetails.promoCodeModel.promoCodeTypeId;
            if (ExpirationDate >= currentdate && EffectiveDate <= currentdate) {
                if (promoCodeType === 1) {
                    handleApplyPromoCode({
                        type: 'percent',
                        value: promoCodeDetails.promoCodeModel.discount,
                        name: promoCodeDetails.promoCodeModel.promoCodeName,
                        codeText: promoCodeText
                    });
                } else {
                    handleApplyPromoCode({
                        type: 'amount',
                        value: promoCodeDetails.promoCodeModel.discount,
                        name: promoCodeDetails.promoCodeModel.promoCodeName,
                        codeText: promoCodeText
                    });
                }
            } else {
                setErrMsg({ msg: 'Promo code entered is expired.' });
                setErrors({ validationPromocode: true });
            }
            console.log(promoCodeDetails);
        } else {
            setErrMsg({ msg: 'Promo code entered is invalid.' });
            setErrors({ validationPromocode: true });
        }
    };

    const onApplyButtonClick = (event) => {
        event.preventDefault();
        if (simpleValidator.current.allValid()) {
            validatePromoCode();
        } else {
            setErrors({ promocode: true });
            simpleValidator.current.showMessages();
            forceUpdate(1);
        }
    };

    const onEnterPromo = (e) => {
        if (e.keyCode === 13) {
            onApplyButtonClick(e);
        }
    };

    return (
        <FormGroup className={(errors.promocode || errors.validationPromocode) && 'form-error'}>
            <Row className='mb-4'>
                <Col
                    lg='8'
                    md='7'
                >
                    <Label
                        for='promocode'
                        className='form-label'
                    >
                        Promo Code
                    </Label>
                    <Input
                        type='text'
                        className='form-control'
                        type='text'
                        name='promoCode'
                        value={promoCodeText}
                        disabled={isPromoApplied}
                        maxlength={16}
                        aria-label='Apply Promo code'
                        onChange={(e) => {
                            setErrMsg({});
                            setErrors(false);
                            setPromoCodeText(e?.target?.value);
                        }}
                        onKeyDown={onEnterPromo}
                    />
                    {!isPromoApplied
                        && simpleValidator.current.message('promoCode', promoCodeText, 'required|alpha_num|max:16')}
                    {errMsg && (
                        <div
                            class='errorMsg'
                            aria-live='polite'
                        >
                            {errMsg.msg}
                        </div>
                    )}
                </Col>
                <Col
                    lg='4'
                    md='5'
                    className='pl-md-0'
                >
                    <button
                        disabled={isPromoApplied}
                        className={` ${classNames(btnPrimary, btn)} ${styles.applyBtn}`}
                        aria-label='apply'
                        onClick={onApplyButtonClick}
                        type='submit'
                    >
                        Apply
                    </button>
                </Col>
            </Row>
        </FormGroup>
    );
};
export default PromoCode;
